import { createContext, useContext } from 'react';

/** Same split as authContext.js: context and hook apart from the component. */
export const ConfigContext = createContext({});

export function useConfig() {
    return useContext(ConfigContext);
}
